import { DeltaServerChangeFeed } from "@hds-products/delta-server-client";
import { ItemBiddingClientEntity } from "../index.mjs";

class ItemBiddingClientChangeFeed extends DeltaServerChangeFeed {
    static DEFAULT_PROJECTION = { type: 'exclude', excludeProperties: ['processedEntries', 'proxyBids'] };
    constructor(deltaServerClient, baseUri, customHeaderFn, projection = ItemBiddingClientChangeFeed.DEFAULT_PROJECTION) {
        super(ItemBiddingClientEntity, deltaServerClient, baseUri, ItemBiddingClientEntity.prototype._meta.entityName, customHeaderFn, projection);
    }
}
export { ItemBiddingClientChangeFeed };
export default ItemBiddingClientChangeFeed;